import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { WindowRefService } from '../../../services/window-ref.service';
import { concat, Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, publishReplay, refCount } from 'rxjs/operators';
import { UrlLayout } from '../../../models/url.model';

const getUrlLayout = (url: string): UrlLayout => {
  if (url.includes('offers')) {
    return 'offers';
  }
  if (url.includes('customer-hub')) {
    return 'customer-hub';
  }
  if (url.includes('refer-a-friend')) {
    return 'refer-a-friend';
  }
  if (url.includes('redirect') || url.includes('version')) {
    return 'nude';
  }
  return 'auth';
};

@Injectable({
  providedIn: 'root',
})
export class RouteWatcherService {
  private readonly navigationEnds$ = this.router.events.pipe(
    filter((event) => event instanceof NavigationEnd),
    // @ts-ignore
    map((event) => event.url)
  );
  // using window.location.pathname for firstUrl b/c otherwise there is a delay on refreshes
  readonly currentUrl$: Observable<string> = concat(
    of(this.windowRefService.nativeWindow.location.pathname),
    this.navigationEnds$
  ).pipe(distinctUntilChanged(), publishReplay(1), refCount());

  readonly currentLayoutType$: Observable<UrlLayout> = this.currentUrl$.pipe(map((url) => getUrlLayout(url)));

  constructor(private readonly router: Router, private readonly windowRefService: WindowRefService) {}
}
